import { actionLabels, categoryLabels } from "@nova/notifications"
import { EventCategory } from "@nova/schemas"

export { actionLabels, categoryLabels }

export const categoryOrder: EventCategory[] = [
    EventCategory.Layers,
    EventCategory.Comments,
    EventCategory.Access,
    EventCategory.Pdfs,
]

export { datePresetLabel, datePresets } from "features/filters/dateRange"
